<div class="ai-tool-executions-container">
  
  <!-- Table Title -->
  <div class="table-header">
    <h2 *ngIf="toolName">Execution of Tool {{toolName}} ({{toolId}})</h2>
    <h2 *ngIf="!toolName && toolId">Execution of Tool {{toolId}}</h2>
    <h2 *ngIf="!toolId">Tool Executions</h2>
  </div>

  <!-- Tool Executions Table -->
  <div class="rubii-table">
    <table style="max-width: 100%">
      <thead>
        <tr>
          <th class="token-th">Token Used</th>
          <th class="time-th">Time Elapsed (s)</th>
          <th class="date-th">Created Date</th>
          <ng-container *ngIf="isLLMTool">
            <th class="vendor-th">LLM Vendor</th>
            <th class="model-th">LLM Model</th>
            <th class="reasoning-th">Reasoning Effort</th>
          </ng-container>
          <th class="input-th">Input</th>
          <th class="output-th">Output</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!toolExecutions || toolExecutions.length === 0" style="text-align: center">
          <td [attr.colspan]="isLLMTool ? 10 : 5" class="no-data-message">
            <div *ngIf="!toolId">Please select a tool to view executions.</div>
            <div *ngIf="toolId">No executions found for this tool.</div>
          </td>
        </tr>
        
        <tr *ngFor="let execution of toolExecutions" class="execution-row">
          <td class="token-td">
            <span>{{execution.tokenUsed || '-'}}</span>
          </td>
          
          <td class="time-td">
            <span>{{formatTimeElapsed(execution.timeElapsed)}}</span>
          </td>
          
          <td class="date-td">
            <span *ngIf="execution.createdate">{{execution.createdate | date:'medium'}}</span>
            <span *ngIf="!execution.createdate">-</span>
          </td>
          
          <!-- LLM Tool specific columns -->
          <ng-container *ngIf="isLLMTool">
            <td class="vendor-td">
              <span>{{execution.input?.extraObj?.llmVendor || '-'}}</span>
            </td>
            
            <td class="model-td">
              <span>{{execution.input?.extraObj?.llmModel || '-'}}</span>
            </td>
            
            <td class="reasoning-td">
              <span>{{execution.input?.extraObj?.llmReasoningEffort || '-'}}</span>
            </td>
          </ng-container>
          
            <td class="input-td">
              <div class="json-preview" (click)="openJsonPopup('Input Data', execution.input)" [title]="'Click to view full JSON'">
                <span class="json-text">{{getTruncatedJsonText(execution.input)}}</span>
              </div>
            </td>
            
            <td class="output-td">
              <div class="json-preview" (click)="openJsonPopup('Output Data', execution.output)" [title]="'Click to view full JSON'">
                <span class="json-text">{{getTruncatedJsonText(execution.output)}}</span>
              </div>
            </td>
        </tr>

        <!-- Pagination Row -->
        <tr>
          <td [attr.colspan]="isLLMTool ? 10 : 5" class="pagination-cell">
            <mat-paginator 
              color="primary" 
              (page)="pageChanged($event)" 
              [length]="page.total"
              [pageSize]="page.pageSize" 
              showFirstLastButtons="true" 
              [pageIndex]="page.pageId - 1"
              [pageSizeOptions]="[6, 10, 25, 50]"
              data-cy="executions-paginator">
            </mat-paginator>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>